export const strenghts = {
  FSEH1: [
    "Connecting with others",
    "Your personality preferences allow you to easily connect and maintain positive relationships with others.",
    "share-alt"
  ],
  FSEH2: [
    "Networking",
    "Meeting new people and striking up conversations with strangers while making positive first impressions comes naturally to you.",
    "handshake"
  ],
  FSEH3: [
    "Positive Outlook",
    "You tend to maintain a positive outlook on things, even in the face of challenging circumstances.",
    "thumbs-up"
  ],
  FSEH4: [
    "Go getter",
    "You're confident in your approach. Tenacious and optimistic. You can make things happen and try to build meaningful connections with other individuals. ",
    "trophy"
  ],
  FSEH5: [
    "High Energy",
    "You have a tenacity and explosive energy. You get excited by novel or new experiences. You tend to make fast decisions and take risks. When you're up you're up and you take others along with you.",
    "battery-half"
  ],

  FSEL1: [
    "Giving others air time",
    "You're happy not to be in the limelight and provide others with the air time to voice their thoughts, opinions and concerns.",
    "comments"
  ],
  FSEL2: [
    "Self Sufficient",
    "Team work is great, but you're happy to fly solo. You're content in being alone and do not require any interaction with other individuals",
    "male"
  ],
  FSEL3: [
    "Thoughtful",
    "You're likely to think about and analyze your own thoughts and behaviors. You tend to focus on one idea at a time, and genuinely listen to and seek to understand the world around yourself.",
    "chess"
  ],
  FSEL4: [
    "Action orientated",
    "You prefer to get things done rather than discuss and contemplate outcomes in group settings. You're happy to sit at a desk alone, yet feel stimulated and energized.",
    "exclamation"
  ],

  FSAH1: [
    "Harmonious style",
    "You prefer to work with teams that work together harmoniously. Your relationships aren't typically characterised with conflict. In fact you try to avoid conflict and competition. Your goal is to cooperate and make sure that everyone is getting along.",
    "heart"
  ],
  FSAH2: [
    "Supportive",
    "Being supportive means that you are likely to put the goals of the group or others ahead of your own. You tend to avoid conflict situations and try to make sure that everyone is feeling supported and validated. You get satisfaction from being there for others.",
    "life-ring"
  ],
  FSAH3: [
    "Altruistic",
    "You are thoughtful and kind to others. Especially generous towards people in a disadvantaged position and willing to help those who need it.",
    "gift"
  ],
  FSAH4: [
    "Peacemaker",
    "You try to avoid conflict with others or resolve such situations. In group situations you will often act as the mediator or ‘peacemaker’, attempting to appease two arguing or conflicting parties.",
    "hand-peace"
  ],

  FSAL1: [
    "Self Assured",
    "You have a strong sense of self and an assured presence that others can gain confidence from.",
    "chess-queen"
  ],
  FSAL2: [
    "Outspoken and bold",
    "You're like to be the one to speak up first, when most people are afraid to ask the difficult question or raise concerns.",
    "bullhorn"
  ],
  FSAL3: [
    "Convincing",
    "In group situations, you value choosing the right option, rather than keeping everyone happy. You try to be objective, unemotional and typically try to convince others to see things your way in a hope to make the right decision.",
    "sitemap"
  ],

  FSCH1: [
    "Reliable",
    "Others know that they can depend on you. You don't give up and step away from a challenge. When you set your mind to something you're likely to see it through.",
    "check"
  ],
  FSCH2: [
    "Consistent",
    "Your approach to different tasks is consistent. You are committed to achieving an outcome, being meticulous and following a set approach to achieve a quality outcome. ",
    "history"
  ],
  FSCH3: [
    "Goal setter",
    "You're likely to be disciplined in planning ahead, setting goals, working toward them, and persisting amid setbacks. If a super ambitious goal can’t be realised, you will switch to a more attainable one rather than getting discouraged and giving up.",
    "bullseye"
  ],
  FSCH4: [
    "Organised",
    "You have a tendency to organise different aspects of your life. You know where everything, how it all fits, and the process to follow to achieve your goals. You don't waste time and get right to work.",
    "archive"
  ],
  FSCH5: [
    "Rule following",
    "You like rules and norms. They give you comfort and help you achieve your goals. You're likely to be orderly, risk averse, and punctual.",
    "book"
  ],
  FSCH6: [
    "Persistent",
    "You possess a high internal drive and discipline. You tend to persist with tasks that are highly challenging or mundane. You push through no matter what. No matter how large the obstacle, you tend not to give up and always find a way to get things done.",
    "flag"
  ],

  FSCL1: [
    "Adaptability",
    "You are very flexible in your approach. You tend to seize opportunities, change priorities and can deviate from long term plans by easily letting go.",
    "arrows-alt"
  ],
  FSCL2: [
    "Satisfied",
    "You are not too tied to professional or career achievements and may find satisfaction from other sources like family, relationships, hobbies and diversions. Additionally you're not likely to be too affected by setbacks and find it easier to move on.",
    "smile"
  ],
  FSCL3: [
    "Spontaneous",
    "Long term planning, details and sticking to a path isn't your type of thing. You're much more likely to be spontaneous and focused on the current situation rather than what might be around the corner. You can bring that spark, challenge or different point of view that can help a group move forward or arrive at a creative solution.",
    "calendar-times"
  ],
  FSCL4: [
    "Externally motivated",
    "You don't gain satisfaction from your internal drive. You are motivated by the external environment, circumstances, or short term rewards. You may draw inspiration from those around you, or the threat of a looming deadline to work tirelessly to achieve an outcome.",
    "trophy"
  ],
  FSCL5: [
    "Good enough",
    "While perfectionists sometimes waste time worrying about every little detail, sometimes good enough is simply good enough. You are likely to seize the moment and deliver something good enough. Which is a lot better than nothing at all.",
    "star-half"
  ],

  FSNH1: [
    "Channeling negatives",
    "While you may experience worry and anxiety, you sometimes are able to channel these negative feelings into positive behaviors, such as going to the gym or eating healthier.",
    "dumbbell"
  ],
  FSNH2: [
    "Positive stress",
    "Stress and anxiety in life can be a good thing to motivate people, these emotions allow you to be more prepared, anticipate challenges especially when you are able to channel your stressors into productive avenues.",
    "check-square"
  ],
  FSNH3: [
    "Preparer",
    "Your emotional disposition means that at times you strive hard, even in the absence of external reward, for fear of failure, falling behind, or as a way to counteract the hazards that you sense ahead. ",
    "clipboard-list"
  ],
  FSNH4: [
    "Emotionally empathic",
    "You feel a range of emotions and often. Due to your own experiences you may find it easier to see things from someone else's view and empathize with their experience",
    "band-aid"
  ],

  FSNL1: [
    "Emotionally Stable",
    "You tend to react less emotionally and are less easily upset. Even in the face of challenges you remain calm and maintain composure. People may look to you to steady the ship in challenging circumstances.",
    "ship"
  ],
  FSNL2: [
    "Even tempered",
    "You tend to maintain an even emotional disposition. While others may experience emotions of extreme highs and lows, you tend to stay somewhere in the middle. You are not emotionally reactive and tend to respond to most situations in a composed, thoughtful and considered way.",
    "anchor"
  ],
  FSNL3: [
    "Go with the flow",
    "You're are a very relaxed person. You have a go with the flow attitude and take life as it comes. You do not worry or take things too seriously. You also tend to like to associate with people who are relaxed just like yourself.",
    "tint"
  ],

  FSOH1: [
    "Sponge",
    "You are open to new experiences and tend to place yourself in situations where you are more likely to acquire new knowledge and skills, even when compared to people in the same environment.",
    "podcast"
  ],
  FSOH2: [
    "Receptivity",
    "You tend to maintain a curious attitude towards people, situations, ideas and things that are new, different or challenge societal norms. You are not closed off and typically find diverse experiences interesting. ",
    "eye"
  ],
  FSOH3: [
    "Mental flexibility",
    "You are mentally adaptable and may consider typically weird or unacceptable behaviour, situations or activities interesting. You have a high tolerance and appetite for change. You are not threatened by it and are very open to new experiences.",
    "lock-open-alt"
  ],
  FSOH4: [
    "Curious",
    "You find learning thrilling. You are interested in a broad range of topics, concepts and ideas. You tend to gravitate from one idea to another and are not threatened by an intellectual challenge.",
    "graduation-cap"
  ],
  FSOH5: [
    "Out of the box",
    "You are typically a good problem solver. When you are faced by a problem you tend to think about creative ways of facing your challenges. You like to think outside of the box and aren't shy to do things differently.",
    "box"
  ],
  FSOH6: [
    "Aesthetics",
    "You exhibit a strong preference for aesthetics, fantasy, and often experience emotional absorption in artistic and cultural experiences.",
    "magic"
  ],
  FSOH7: [
    "Creative",
    "You have preference for creative outlets, exploring emotions, gut feelings and use empathy to make decisions. You often engage in vivid imagination, fantasy, try new approaches, enjoy fine arts and cultural experiences",
    "paint-brush"
  ],

  FSOL1: [
    "Practical",
    "You are not very artistic or imaginative, you do not see value in unnecessary things. You tend to be dedicated to your work and look at ways to solve problems with a practical approach, ways that work.",
    "wrench"
  ],
  FSOL2: [
    "Traditional",
    "You aren't into exploring or learning about new ideas, understanding taboo topics or people who are too different for their own good. Your first instinct is to go for tried-and-true methods, ´do things properly´, follow a structured routine and not deviate from the 'norm'.",
    "university"
  ],
  FSOL3: [
    "Routine",
    "You like following a set plan. Chopping and changing too much can make you frustrated and takes you further away from your goals.",
    "list-ol"
  ],
  FSOL4: [
    "Black and white",
    "You're often able to make decisions quickly. You see things as black and white, with no grey areas.",
    "map-signs"
  ]
};

export const weaknesses = {
  FDEH1: [
    "High Energy",
    "Your strong preference to interact with others, be talkative, and positive can be burdensome to others who may prefer to work in a quiet focused environment. Be mindful of other people and monitor your energy to make sure that you do not drive away people who do not share outgoing nature.",
    "battery-full"
  ],
  FDEH2: [
    "Boredom",
    "You have a susceptibility to get bored easily. You may need constant activity around you, music playing in the background and others to converse with. Make sure that you keep yourself stimulated when working on detail focused tasks, take regular breaks and switch between short term payoffs and long term payoffs to keep your interest up.",
    "hourglass-start"
  ],
  FDEH3: [
    "Alone time",
    "Not being around people. Your biggest enemy. It's not that you can't work alone, you'd just prefer to be in a group and it can really take toll on your productivity. Where possible try to find similar minded people and structure activities as group brainstorming sessions, group planning days or peer feedback round tables.",
    "universal-access"
  ],
  FDEH4: [
    "Excitement seeker",
    "You are likely to be interested in novel experiences. This also may include risky experiences. Sometimes this means that the regular structured life that many others lead does not appeal to you. Make sure that when you do engage in new experiences or step outside of the norm, that you reflect and take on any new learnings. ",
    "mask"
  ],
  FDEH5: [
    "Balance talk",
    "Although forming relationships and holding conversation may be a strength, it’s important that you find a balance between talking and listening. Validate others and make sure they feel heard. This strategy will help you become a resource for others, as well as maintain solid meaningful relationships that extend beyond the superficial.",
    "balance-scale"
  ],
  FDEH6: [
    "Impulsive",
    "You have a restless desire to explore new boundaries, work well in rapidly changing environments, ready to move on at short notice, whether this is physically or to a new relationship, job or career. Sometimes you can commit to new adventures without thinking through all of the consequences. Before making a decision take some time to consider all the pros and cons. Don't just say yes to everything.",
    "bomb"
  ],

  FDEL1: [
    "Connecting with others",
    "You personality preferences mean that you may find it hard to form relationships with others, especially if they are not known to you. Where necessary, step outside of your comfort zone and try to lead the conversations. Use small talks. Find common ground and you may be surprised that others respond in a positive way.",
    "share-alt"
  ],
  FDEL2: [
    "Distracted by noise",
    "You have a preference for solitude and silence. You're likely to suffer distractions from people, noise, or stimulants of any kind. These can be really disruptive to your ability to focus. You're likely to feel less comfortable, less efficient, and less helpful in a noisy or group environment.",
    "headphones"
  ],
  FDEL3: [
    "Silent",
    "You have probably thought things through thoroughly, have great ideas and thoughts that could often help others. Unfortunately, you not vocal or volunteer information in group settings. As a result your ideas and opinions may often get overlooked in favor of the more confident group contributors. ",
    "microphone-slash"
  ],
  FDEL4: [
    "Energy levels",
    "You may find that you are often feeling tired, or burnt out by meetings and interaction with other people. Sometimes others can read this as you being uninterested, closed off or unapproachable. Set aside time to engage with others, but make sure that you let them know your preferred methods of communication.",
    "battery-half"
  ],

  FDAH1: [
    "Making hard decisions",
    "Your preference for accomodating others, can lead to internal conflict when difficult decisions need to be made. You may find it challenging to make decisions that have drawbacks or impact negatively on other people.",
    "question"
  ],
  FDAH2: [
    "Avoiding conflict",
    "Your tendency to avoid conflict when dealing with other people may be counterproductive. At times conflict is necessary to progress or resolve certain challenges. You may experience personal growth from engaging in more opinionated exchanges with others and respectfully challenging their point of view when you disagree.",
    "times"
  ],
  FDAH3: [
    "Putting others ahead of self",
    "Being group and people orientated often means that you put the good of the group or others ahead of yourself. Look for opportunities to find win win situations for everybody, even yourself.",
    "users"
  ],
  FDAH4: [
    "Asking and telling",
    "You may overwork yourself due to an inability to delegate appropriately or ask others for help when you are stuck. You may also have difficulty delivering bad news, giving criticism, and standing up for yourself in the face of unfair criticism.",
    "comment-alt"
  ],
  FDAH5: [
    "Separate identity",
    "Sometimes you may find it very difficult to separate your identity from the group. You get a lot of satisfaction from belonging. This means that at times you will go with the group even though you may not really agree with it. Challenging norms and group decisions is healthy and often leads to better outcomes. ",
    "id-card"
  ],

  FDAL1: [
    "Confrontational",
    "At times it may appear like you enjoy being argumentative. Although holding a position that is not in agreeance with others is fine, you may need to be more flexible in relinquishing control. Allowing others to drive the agenda and lead, even when you are not in 100% agreement can be beneficial to team harmony.",
    "people-arrows"
  ],
  FDAL2: [
    "Inconsiderate of others perspective",
    "Being empathic can be challenging at the best of times. Try and be considerate of others' emotional well being and the position they are coming from. Take their thoughts, feelings and actions into consideration and think about how your responses may impact others before expressing them.",
    "eye-slash"
  ],
  FDAL3: [
    "Persistent or inflexible approach",
    "Trusting in others is important. Allowing or incorporating other perspectives and thoughts can strengthen our own approach. Work on being more emotionally supportive and inclusive of others.",
    "shield-alt"
  ],
  FDAL4: [
    "Agree to disagree",
    "You have a preference to work according to your own tune. Your relationships can suffer from conflict due to your preference to test yourself against others. Your goal should be to cooperate and try to accommodate others in order to create better working relationships.",
    "exchange-alt"
  ],
  FDAL5: [
    "Restrain judgement",
    "Restrain initial thoughts or judgements of others. Giving more time to others before writing them off, may help you form a more accurate perception of others than your natural instincts may initially indicate.",
    "crosshairs"
  ],
  FDAL6: [
    "Self Focused",
    "You tend to be more focused on your own personal needs, even when these conflict with the interests of others. As a result your peers may view your behaviour as somewhat selfish. Try to take the needs of others into account when interacting, compromising or trying to achieve a shared goal with others.",
    "street-view"
  ],
  FDAL7: [
    "Suspicious",
    "Your low score on agreeableness can manifest itself in suspicion and distrust of others. Because you are unsure of the motives of others you may be more argumentative, and be less willing to engage in conversations with, or socialise with, unfamiliar people. Trust that most people are not naturally out to cause you distress.",
    "low-vision"
  ],

  FDCH1: [
    "Decision making",
    "You may find that sometimes you get bogged down by the details. This means that making any type of decision can take longer and have a cost attached to it if there is a critical deadline.",
    "question"
  ],
  FDCH2: [
    "Multi focus",
    "Your level of conscientiousness is great in achieving tasks, however you may find it challenging to split your attention amongst multiple tasks. As a consequence it may take you longer to shift focus, ramp up and down between tasks.",
    "sliders-h"
  ],
  FDCH3: [
    "Rule Follower",
    "While you have a strong appreciation for rules, following the rulebook at all times can be counterproductive, interfere, block or annoy creative and innovative oriented people. Most importantly, strictly adhering to rules can stifle innovation. Try to appreciate that sometimes rules do not apply cleanly and experiment when possible.",
    "book"
  ],
  FDCH4: [
    "Risk Averse",
    "You may have trouble dealing with ambiguity and making decisions that have risk attached. Taking a leap of faith without all the facts, information or potential outcomes can be anxiety provoking. This mindset, while safe, can prevent you from trying new things and experimenting. ",
    "bolt"
  ],
  FDCH5: [
    "Fault attribution",
    "Being detail minded, driven to achieve quality outcomes, and follow rules means that when things do break down you may step up and take the blame. It may not be directly your fault, but because of your conscientiousness you may feel like the negative outcome is directly attributed to your efforts. Be realistic about the bad outcome. Analyse it! You're good at this and don't automatically attribute the failure to yourself.",
    "times"
  ],
  FDCH6: [
    "Perfectionist",
    "Sometimes you may spend too much time worrying about every little detail that you miss the forest through the trees. A good something is better than a perfect nothing. You may fail seize the moment and deliver something 'good enough' or something all together.",
    "tree"
  ],

  FDCL1: [
    "Weak Planning",
    "You have a preference for living in the moment. Planning and thinking about the long term is something that you find challenging and mundane. As far as you are concerned, considering all of the different future scenarios could be a waste of time or even pointless. You are very changeable and reactive to your environment, and as a result you may find it hard to predict, plan and strategize for the long term.",
    "calendar-times"
  ],
  FDCL2: [
    "Lack Persistence",
    "You lack the internal drive and discipline to persist with tasks that may end up being too challenging, mundane or not as interesting as a new distraction. Persist, you may feel incredible self relief or a sense of accomplishment by seeing things through.",
    "tasks"
  ],
  FDCL3: [
    "Impulsive",
    "You may find it difficult to show self-discipline, motivate yourself to complete mundane tasks, and act dutifully. You have a preference to ignore rules, try creative solutions even in the face of failure, and make decisions without considering all of the facts.",
    "bomb"
  ],
  FDCL4: [
    "Reliability",
    "Others may find it difficult to depend on you. You tend to give up and step away from a challenge before even committing fully. You may have a low threshold for long term projects where there isn't a short term payoff. Completing tasks can be challenging and you may find yourself moving on to new projects rather than finishing old ones.",
    "check"
  ],
  FDCL5: [
    "Rule Avoidant",
    "You don't have a strong appreciation for rules. For you following a rulebook can be challenging and tedious. While you may have a strong preference to be more adaptable and carefree in your approach, adhering to rules can provide consistency and reliability to others around you. They may feel like they are able to depend on you. Try and balance your need for novelty with being reliable and consistent for others.",
    "book"
  ],
  FDCL6: [
    "Procrastinator",
    "You can procrastinate, and you sometimes tend to put off your responsibilities until the last minute. If something fun comes up, it doesn't bother you to put your responsibilities off until the next day.",
    "cloud"
  ],

  FDNH1: [
    "Emotionally Reactive",
    "Your emotional responses to situations that would not affect most people tend to be over the top and volatile.Take a moment, remove yourself from the situation and assess what happened calmly.",
    "thermometer-three-quarters"
  ],
  FDNH2: [
    "Moody",
    "When compared to others you may experience more negative emotions and end up in a bad mood more frequently. ",
    "thumbs-down"
  ],
  FDNH3: [
    "Control",
    "You may experience difficulty in thinking clearly, controlling your feelings and being able to cope with stress. In situations where things feel like they are getting too much, take a step back and try to steady yourself. More importantly, find ways to channel your stressors into more productive avenues such as eating healthy, exercising, preparing adequately and anticipating problems that you can deal with before they happen.",
    "gamepad"
  ],
  FDNH4: [
    "Self Conscious",
    "At times you may feel vulnerable and open to the judgement of others. The anxiety of being put in situations where you have limited control or things can go wrong may prove too much or get on top of you. Ask others for feedback, invite them to provide you with ways to improve, reflect on those situations that stress you out and grow from them. Use them as a point of strength.",
    "id-card-alt"
  ],
  FDNH5: [
    "Worrier",
    "You may experience feelings of anxiety or worry about future situations. There are reasons to worry, and reasons not to worry. If your reasons are realistically tied to what's happening in your life, don't add guilt over feeling negative to your existing feelings of sadness or anxiety. Make sure to use this anxiety as a way of preparing, staying ahead, or anticipating any challenges that may arise.",
    "calendar-alt"
  ],

  FDNL1: [
    "Not bothered",
    "Your lack of emotional reactivity, calm presence and even tempered nature may mean that sometimes people can misinterpret this as a lack of not caring. Make sure that you communicate your concerns to others and help them understand why you may not be panicking when they may be feeling overwhelmed.",
    "thermometer-quarter"
  ],
  FDNL2: [
    "Lack anticipation",
    "Stress and anxiety in life can be a good thing to motivate people, these emotions allow you to be more prepared and anticipate challenges. Your relaxed nature may mean that sometimes you don't anticipate risks or stress about certain negative scenarios.",
    "binoculars"
  ],
  FDNL3: [
    "Emotionally unempathetic",
    "Other people are likely to stress and feel more negative emotions than you. You may find it hard to understand or place yourself in their shoes. Make sure when someone is feeling stressed or down in situations where you may not be, that you take the time to try to understand their perspective and empathize with them. Help them by providing ways to deal with their negative mood or emotional volatility.",
    "anchor"
  ],

  FDOH1: [
    "Intellectual superiority",
    "You're a quick learner. Even quicker at analyzing problems, patterns or fuzzy rule sets. Because others can sometimes take longer than you to work things out for themselves they may see your eagerness to move on as pompous, short and judgemental of their capability. You need to be mindful that others may take more time than you to arrive at a conclusion.",
    "chess"
  ],
  FDOH2: [
    "Novelty seeking",
    "You hate being in a routine. You're constantly looking for new things to do, new challenges to overcome. If things become too repetitive you can feel like you're in a slump and often look to make a change. This flexibility could be seen as a lack of commitment or passion, being too changeable and being bored.",
    "rocket"
  ],
  FDOH3: [
    "Idea generator",
    "You have a flair for being creative. Thinking about new ways to do things. Sometimes this can be too much for others. You can be unfocused or generate too many ideas that end up leading you up the garden path. This can at times be frustrating to others. When working with more concrete or traditional people try not to overwhelm them. Offer practical solutions and stick to a plan.",
    "lightbulb"
  ],
  FDOH4: [
    "Rebellious",
    "You tend to have a rebellious streak. You don't value conformity, can sometimes break rules because they make no sense to you and question well established frameworks. While these are positive characteristics if you are trying to solve problems creatively, it can be counterproductive if you are always trying to reinvent the wheel.",
    "user-secret"
  ],
  FDOH5: [
    "Explorer",
    "You always remain mentally agile when approaching problems, handing whatever life throws at you. However, this trait also means that you typically take more time to make decisions than others do. Try to narrow down your ideas to a few critical approaches that may have worked for you in the past.",
    "compass"
  ],

  FDOL1: [
    "Routine",
    "You like following a set plan. Chopping and changing too much can make you frustrated and takes you further away from your goals. You need to be in an environment that's predictable.",
    "list-ol"
  ],
  FDOL2: [
    "Black and white",
    "You often see things as black and white. You do not see shades of grey. As a result you can quickly jump to conclusions and do not like to entertain that there may be a fuzzy middle area. This can sometimes limit discussions or your ability to interact with people who do not follow the norm,  enjoy to explore or discuss abstract ideas.",
    "map-signs"
  ],
  FDOL3: [
    "Traditional",
    "You aren't into trying untested methods. Your first instinct is to go for tried-and-true methods, follow a structured routine and not deviate too much from the plan. This can be a problem when considering new problems, situations, people or challenges.",
    "university"
  ]
};

/* REDUCED READING AGE */

export const strenghts_reduced = {
  FSEH1: [
    "Connecting with others",
    "You find it easy to make new friends and talk to strangers. You have many positive relationships with friends, family, and workmates.",
    "share-alt"
  ],
  FSEH2: [
    "Networking",
    "You find it easy to meet new people and talk openly without awkward silences. Most people you meet seem to like you.",
    "handshake"
  ],
  FSEH3: [
    "Positive Outlook",
    "You tend to look on the bright side of life, even in tough times.",
    "thumbs-up"
  ],
  FSEH4: [
    "Go getter",
    "You've got spunk. Friends would say you're confident, determined, and optimistic. You make things happen and build valuable connections with others.",
    "trophy"
  ],
  FSEH5: [
    "High Energy",
    "You're a blazing ball of energy and grit. You're excitable, a risk-taker, and tend to make fast decisions. When you're doing well, you bring others along with you.",
    "battery-half"
  ],

  FSEL1: [
    "Giving others air time",
    "You don't need to speak up or steal attention. You're happy to let others voice their thoughts and opinions instead.",
    "comments"
  ],
  FSEL2: [
    "Self Sufficient",
    "Team work is great, but you're also happy to fly solo. You don't need to be around other people, as you enjoy working alone.",
    "male"
  ],
  FSEL3: [
    "Thoughtful",
    "You spend a lot of time thinking about your own thoughts and behaviours. You prefer to focus on ideas in depth, so you can genuinely listen to and seek to understand the world around you.",
    "chess"
  ],
  FSEL4: [
    "Action orientated",
    "You get things done like a boss. You prefer to sit at your desk and get things moving, instead of talking and planning as a group. Solo time energises you.",
    "exclamation"
  ],

  FSAH1: [
    "Harmonious style",
    "Why can't everyone just get along? That's your aim in life, so you tend to be easy-going. You try to avoid conflict and competition as much as possible, preferring to work with teams who get on well together.",
    "heart"
  ],
  FSAH2: [
    "Supportive",
    "You often put the goals of the group ahead of your own. This could be because you don't like conflict, so you try to make everyone else feel supported and heard. Truth is, you feel good when you can support others.",
    "life-ring"
  ],
  FSAH3: [
    "Altruistic",
    "You are thoughtful and kind to others and want to help those in need. You help and give your time generously.",
    "gift"
  ],
  FSAH4: [
    "Peacemaker",
    "You might be known to others as the 'peacemaker'. You try to avoid conflicts and are usually the one that helps resolve any friction or arguments between others.",
    "hand-peace"
  ],

  FSAL1: [
    "Self Assured",
    "You know who you are. You have an assured presence and a strong sense of self that others gain confidence from.",
    "chess-queen"
  ],
  FSAL2: [
    "Outspoken and bold",
    "You're likely to be the one who speaks up first, when most people are afraid to ask difficult questions or raise their concerns.",
    "bullhorn"
  ],
  FSAL3: [
    "Convincing",
    "When making decisions, you'll go with 'what's right' instead of trying to keep everyone happy. You see things as they are, the good and the bad. You like helping others see things from the same balanced view, hopeful the right decision can be made.",
    "sitemap"
  ],

  FSCH1: [
    "Reliable",
    "People know they can depend on you. When you set your mind to something, you're likely to finish it - you don't give up easily.",
    "check"
  ],
  FSCH2: [
    "Consistent",
    "When you commit to achieving something, you stick with what works! You are always careful, focus on details and quality outcomes.",
    "history"
  ],
  FSCH3: [
    "Goal setter",
    "You love to plan, set goals, and work towards them. You'll keep going even if there's a roadblock, so you never give up. Even when a goal gets too hard to achieve, you'll switch to an achieveable one to keep yourself going.",
    "bullseye"
  ],
  FSCH4: [
    "Organised",
    "You know where everything is, how it fits, and what process to follow to achieve your goals in life. You get right to work; not one to waste time.",
    "archive"
  ],
  FSCH5: [
    "Rule following",
    "Following the rules is comforting for you - rules help you achieve your goals. You're likely to be a neat person, risk-averse, and always on time!",
    "book"
  ],
  FSCH6: [
    "Persistent",
    "You have a strong internal drive and self-discipline. You tend to persist with tasks that are highly challenging or boring. You'll push through no matter what. Even if faced with a large obstacle, you'll always find a way to get things done.",
    "flag"
  ],

  FSCL1: [
    "Adaptability",
    "You're very flexible in your approach to most things. You tend to grab opportunities when you see them, so you'll easily adjust your priorities and  long-term plans to fit.",
    "arrows-alt"
  ],
  FSCL2: [
    "Satisfied",
    "You're pretty chill about life, not feeling too attached to professional or career achievements. Instead, you probably find satisfaction from people, family, and hobbies. You can easily move past setbacks and jump onto the next thing.",
    "smile"
  ],
  FSCL3: [
    "Spontaneous",
    "Long term planning, details and sticking to a path isn't your type of thing. You're more likely to take a casual approach, focusing on what's current instead of what 'could be'. Your free spirit can bring a spark and a different point of view that can help a group move forward to find a creative solution.",
    "calendar-times"
  ],
  FSCL4: [
    "Externally motivated",
    "You're not motivated by your internal drive to accomplish but rather your environment, situation, or short-term rewards. You may draw inspiration from people around you, or from the threat of a deadline to kick you into gear and finish your work.",
    "trophy"
  ],
  FSCL5: [
    "Good enough",
    "You know that creating something 'good enough' is good enough, so you don't waste time chasing perfection. You seize the moment and deliver something, which is a lot better tha nothing.",
    "star-half"
  ],

  FSNH1: [
    "Channeling negatives",
    " It's possible you'll feel worried and anxious every so often, but you're able to channel these feelings into positive behaviour, like going for a run or eating healthier.",
    "dumbbell"
  ],
  FSNH2: [
    "Positive stress",
    "Stress and anxiety in life can be a good thing to motivate people. These emotions help you better prepare for challenges, especially when you can channel your stressors into productivity.",
    "check-square"
  ],
  FSNH3: [
    "Preparer",
    "The way you process emotion means that at times, you work really hard even when there's no external reward driving you. Instead, you can be motivated by preparing for any future problems that can happen. The fear of failure or of falling behind you feel at times helps you.",
    "clipboard-list"
  ],
  FSNH4: [
    "Emotionally empathic",
    "You feel a range of emotions, and often. Due to your own experiences, you may find it easier to see things from someone else's view and connect with them.",
    "band-aid"
  ],

  FSNL1: [
    "Emotionally Stable",
    "Rock solid, you don't tend to react emotionally or get easily upset by things. Even in the face of challenges, you can remain calm and stable. People may look to you to steady the ship in challenging times.",
    "ship"
  ],
  FSNL2: [
    "Even tempered",
    "You tend to keep an even emotional state. While others may swing between emotional highs and lows, you tend to stay somewhere in the middle. Chill. You're not emotionally reactive and tend to respond to most situations in a composed and thoughtful way.",
    "anchor"
  ],
  FSNL3: [
    "Go with the flow",
    "You're a super relaxed person. You prefer to go with the flow and take life as it comes. You don't worry about much or take things too seriously. You probably spend your time with other people who are as relaxed as you.",
    "tint"
  ],

  FSOH1: [
    "Sponge",
    "You're open to new experiences and like to place yourself in situations where you'll learn new knowledge and skills.",
    "podcast"
  ],
  FSOH2: [
    "Receptivity",
    "You are curious about people, situations, ideas, and all things new or different. You have an open mind and find diverse experiences interesting.",
    "eye"
  ],
  FSOH3: [
    "Mental flexibility",
    "You are mentally adaptable and open to most new things. You also have a strong appetite for change. You're not threatened by 'abnormal’ and may consider things that are typically weird or unacceptable interesting.",
    "lock-open-alt"
  ],
  FSOH4: [
    "Curious",
    "Learning thrills you. You're interested in lots of topics, concepts, and ideas. You tend to move from one idea to another and are not threatened by intellectual challenges.",
    "graduation-cap"
  ],
  FSOH5: [
    "Out of the box",
    "You're a good problem solver who enjoys thinking outside of the box. You can usually think of a creative way to beat most challenges.",
    "box"
  ],
  FSOH6: [
    "Aesthetics",
    "You like beautiful things. You often find yourself emotionally absorbed in culture and arts.",
    "magic"
  ],
  FSOH7: [
    "Creative",
    "You're a creative person who tends to make decisions based on your emotions and 'gut feel'. Your colourful imagination enjoys fantasy, the finer arts, and cultural experiences.",
    "paint-brush"
  ],

  FSOL1: [
    "Practical",
    "You're dedicated to your work and use your practical mind when solving problems. You don't consider yourself artsy or creative, you don't have much time or interest in unnecessary things.",
    "wrench"
  ],
  FSOL2: [
    "Traditional",
    "You prefer to stick to your routine and tried and true ways familiar to you, because you know it works. You don't often explore new ideas or taboo topics, or bother getting to know people who are too different for their own good.",
    "university"
  ],
  FSOL3: [
    "Routine",
    "You work at your best when you're following a set plan. Habits and routine provide comfort, allowing you to thrive. This means you can sometimes get frustrated by frequent changes.",
    "list-ol"
  ],
  FSOL4: [
    "Black and white",
    "You can often make decisions quickly because you see things only in black and white. Yes and no. For you, there's no grey area for confusion.",
    "map-signs"
  ]
};

export const weaknesses_reduced = {
  FDEH1: [
    "High Energy",
    "You like to talk and be around others, but some quieter people may find this high energy distracting, especially at work or school. Be mindful of other people who may not be as loud and outgoing as you.",
    "battery-full"
  ],
  FDEH2: [
    "Boredom",
    "You can get bored easily. You may need constant activity around you, like music playing or people to talk to. To stay focused at work, take regular breaks and split your time between simple short  tasks and longer tasks.",
    "hourglass-start"
  ],
  FDEH3: [
    "Alone time",
    "You don't enjoy being alone at work, as you prefer to be in a group. Working alone can slow you down, so you'll want to find other outgoing people to be around. If possible, sign up for group projects or team events to keep yourself energised.",
    "universal-access"
  ],
  FDEH4: [
    "Excitement seeker",
    "You like adventure and trying new things (sometimes risky things!). So, you could be bored by a normal, structured life. When you try something new or outside of 'the norm', reflect on what you've learned to help you grow.",
    "mask"
  ],
  FDEH5: [
    "Balance talk",
    "While it's easy for you to talk to others and form good relationships, sometimes, you might talk too much. Do you need to balance talking with listening? It's important to let others speak up and feel heard, too. By showing them your support, you'll improve these relationships.",
    "balance-scale"
  ],
  FDEH6: [
    "Impulsive",
    "You move fast and can adjust well during change. You are ready to go at short notice, whether this is physically (let's go, now), or to a new relationship or job. But be mindful of saying 'yes' to everything! Sometimes, you can commit to a new adventure without thinking it through. So, take your time to consider what's really best.",
    "bomb"
  ],

  FDEL1: [
    "Connecting with others",
    "You may struggle to talk or make friends with people you don't already know. Which means that sometimes, you'll need to force yourself out of your comfort zone. Practice making small talk and, try to speak up and lead conversations where necessary.",
    "share-alt"
  ],
  FDEL2: [
    "Distracted by noise",
    "You prefer working alone in silence because you're distracted by people and noises. When you can't focus, you're likely to feel uncomfortable and less focused.",
    "headphones"
  ],
  FDEL3: [
    "Silent",
    "While you can spend a lot of time thinking things through and coming up with great ideas, you may not always confidently share them. Unfortunately, this could mean your clever ideas and opinions are overlooked in groups.",
    "microphone-slash"
  ],
  FDEL4: [
    "Energy levels",
    "If you spend too much time with other people (in team meetings or group projects), you will likely feel tired or low in energy. Sometimes, other people can see this as you being bored or unfriendly. It's important you tell people how you prefer to work and communicate, but make sure you also make time for connection.",
    "battery-half"
  ],

  FDAH1: [
    "Making hard decisions",
    "Find it hard to make tough decisions? You prefer to keep the peace by pleasing others, but make sure you aren't always ignoring your own needs. This can create inner conflict. You may also find it hard to make a decision that will negatively affect others.",
    "question"
  ],
  FDAH2: [
    "Avoiding conflict",
    "Sometimes, avoiding conflict can work against you. Not all conflict is bad. Sometimes, it can help to progress or resolve challenges. Perhaps next time you don't agree with someone, you could try sharing your opinion with them, respectfully, of course. You both might learn something new that helps you grow.",
    "times"
  ],
  FDAH3: [
    "Putting others ahead of self",
    "You'll often put the needs of others ahead of your own. When in these situations, try and find a win win for everyone (even you!).",
    "users"
  ],
  FDAH4: [
    "Asking and telling",
    "You may find it hard to tell others what to do or ask for help when you get stuck. It could also be hard for you to share bad news or give someone negative feedback. When someone unfairly criticises you, you might struggle to stand up for yourself.",
    "comment-alt"
  ],
  FDAH5: [
    "Group Identity",
    "You feel satisfied belonging to a group. But this could mean you'll go along with them, even when you don't agree with them. Remember, it's healthy to challenge group decisions and what's 'normal', because it can lead to a better result. Even though you enjoy your group, it's important you keep your identity separate.",
    "id-card"
  ],

  FDAL1: [
    "Confrontational",
    "At times, people might think you like being argumentative. While it's OK to have an opinion that others don't agree with, you may need to relax your approach. Allowing others to lead the conversation, even when you don't 100% agree, can help the team work better together, harmoniously.",
    "people-arrows"
  ],
  FDAL2: [
    "Inconsiderate of others perspective",
    "You may be quick to express yourself without first considering the thoughts, feelings, and emotional wellbeing of those you're with. It's not always easy or natural for some people to do this. Try thinking about how your responses may affect others before sharing them.",
    "eye-slash"
  ],
  FDAL3: [
    "Inflexible approach",
    "It's important you show trust in others and allow different opinions, even if you don't always agree. Try being more open and emotionally supportive of others.",
    "shield-alt"
  ],
  FDAL4: [
    "Agree to disagree",
    "You love working to your own beat. Sometimes, your relationships can suffer if your solo approach goes against others, causing a rift. It's important you always try to work together to create better working relationships.",
    "exchange-alt"
  ],
  FDAL5: [
    "Slow down judgements",
    "Don't be too quick to judge other people. Take your time getting to know someone before writing them off. It may help you form a truer view of their character than your first gut feel.",
    "crosshairs"
  ],
  FDAL6: [
    "Self Focused",
    "You tend put your needs above others. Try thinking about what other people want and need when you're working together on shared goals.",
    "street-view"
  ],
  FDAL7: [
    "Suspicious",
    "You may find it hard to trust other people. Maybe you aren't sure what they want and why they want it. But your distrust could make you look hostile or unwilling to talk with or spend time with people you don't know. Try to accept that most people are not naturally out to cause you harm.",
    "low-vision"
  ],

  FDCH1: [
    "Decision making",
    "Sometimes, you can get stuck in the details, so it takes you longer to make a decision. Be mindful that taking too long can be costly when there is a strict deadline.",
    "question"
  ],
  FDCH2: [
    "Multi-focus",
    "You are dutiful and committed to finishing your tasks (one at a time). Sometimes, it can be hard for you to split your focus on different things. This means you can take longer to shift focus when moving between tasks.",
    "sliders-h"
  ],
  FDCH3: [
    "Rule Follower",
    "You respect rules and follow them closely. However, following the rules at *all* times can cause trouble if your rules block innovation, annoy creative people or lead to big delays. Some rules can be broken, so try and be open and flexible when it's needed.",
    "book"
  ],
  FDCH4: [
    "Risk Averse",
    "You might struggle to make decisions when there are risks attached. You worry when forced to decide something without all the facts. While avoiding risk is safe, it can stop you from trying new things.",
    "bolt"
  ],
  FDCH5: [
    "Fault attribution",
    "You are so detail minded, driven, and respectful of rules that when things go wrong, you may step up and take the blame. Even if it's not your fault! But because you are so conscientious, you may feel that it is. Be realistic about any bad outcomes and study what happened. Try not to accept fault for all failures automatically.",
    "times"
  ],
  FDCH6: [
    "Perfectionist",
    "Do you sometimes miss the forest for the trees? If you spend a lot of time worrying about every little detail, you could miss out on the moment altogether. Remember that a 'good something' is better than a 'perfect nothing'.",
    "tree"
  ],

  FDCL1: [
    "Weak Planning",
    "You like to live in the moment. Thinking about the future and planning it, is not something you enjoy. You probably find it's pointless thinking about all the different future scenarios, because so much can change. However, as you're so reactive to your environment, you may find it hard to predict and plan for the long-term.",
    "calendar-times"
  ],
  FDCL2: [
    "Lack Persistence",
    "If something is too hard or boring for you, you may lose interest in finishing it. When this happens, keep working at it because you may feel a sense of relief or accomplishment that you finished.",
    "tasks"
  ],
  FDCL3: [
    "Impulsive",
    "You tend to ignore the rules. You will boldly pursue creative ideas (even in the face of failure) and can make decisions without considering all the facts. You follow your instincts; however, this could mean you find it hard to show self-discipline, finish dull tasks, and act dutifully.",
    "bomb"
  ],
  FDCL4: [
    "Reliability",
    "Others may not be able to depend on you, because you tend to give up on a challenge before you fully commit. You may find it hard to stick with long-term projects when there's no short-term reward to interest you. So, you can struggle to finish things because you'd rather move onto something new.",
    "check"
  ],
  FDCL5: [
    "Rule Avoidant",
    "You can find rules boring and hard to follow. While you prefer to be more adaptable and carefree when approaching tasks, sometimes rules can provide consistency and reliability for others. Are people able to depend on you? Try to balance your need for originality while being reliable and consistent for others.",
    "book"
  ],
  FDCL6: [
    "Procrastinator",
    "You can procrastinate and put off your responsibilities until the last minute. Especially, if something fun comes up!",
    "cloud"
  ],

  FDNH1: [
    "Emotionally Reactive",
    "You can be a bit sensitive to some situations that wouldn't bother other people. Your reaction can be explosive and over the top. Try taking a moment to remove yourself from that situation, and calmly assess what's really happened.",
    "thermometer-three-quarters"
  ],
  FDNH2: [
    "Moody",
    "You may experience more negative emotions compared to others and find yourself in a bad mood often.",
    "thumbs-down"
  ],
  FDNH3: [
    "Control",
    "You may find it hard thinking clearly, controlling your feelings and coping with stress. When things feel like they're getting too much, take a deep breath and a step back, and try to steady yourself. It's important for you to find ways to channel your stressors into more positive and productive things, like eating healthy, exercising, and preparing for problems before they happen.",
    "gamepad"
  ],
  FDNH4: [
    "Self Conscious",
    "At times, you may feel vulnerable and open to the judgement of others. You can also struggle in situations where you have little control, or when things can go wrong. Instead of letting this overwhelm you, ask others for feedback. Ask them to suggest ways you can improve and reflect on these stressful situations as lessons to help you grow. Use them as a point of strength.",
    "id-card-alt"
  ],
  FDNH5: [
    "Worrier",
    "You can get caught up feeling anxious or worried about future scenarios (real or imagined). Remember that there are reasons to worry, and reasons not to worry. If your worries are realistic and tied to something happening in your life, make sure you're not overwhelming yourself with extra feelings of stress or guilt. Ask for help. And practice  using your negative thoughts as a way to better prepare for any future challenges.",
    "calendar-alt"
  ],

  FDNL1: [
    "Not bothered",
    "Your calm presence, even tempered nature, and lack of emotional reactivity can sometimes be misinterpreted as you not caring. Make sure you share your thoughts and concerns with others to help them understand why you're not panicking when they're feeling overwhelmed.",
    "thermometer-quarter"
  ],
  FDNL2: [
    "Lack anticipation",
    "Some stress and anxiety in life can be a good thing to motivate people and better prepare them for challenges. You tend to be more relaxed in life. But your relaxed nature may mean that sometimes you get caught out. Make sure you still consider the risks and potential negative scenarios.",
    "binoculars"
  ],
  FDNL3: [
    "Emotionally unempathetic",
    "Other people will likely stress more and feel more negative emotions than you do. Possibly, you'll find it hard to understand them or place yourself in their shoes. When someone is feeling stressed or down in situations where you may not be, make sure you reach out and try to understand what they're feeling. Try to empathise with them and offer ways to help them deal with their negative mood.",
    "anchor"
  ],

  FDOH1: [
    "Intellectual superiority",
    "You're a fast learner. You're even faster at analysing problems and patterns. But because others can sometimes take longer than you, they may see your eagerness to move on as arrogant and judgemental of their intelligence. Be mindful that some people need more time to work things out.",
    "chess"
  ],
  FDOH2: [
    "Novelty seeking",
    "You hate routine. You're always looking for new things to do and new challenges to beat. When things get repetitive, you can feel like you're in a slump and so will look to make a change. This energy and flexibility could be seen as being bored, unsettled and lacking commitment.",
    "rocket"
  ],
  FDOH3: [
    "Idea generator",
    "You have creative flair, always thinking about new ways to do things. Sometimes, this creativity can be too much for others, frustrating them. They may find you unfocused or generating too many ideas that don't go anywhere.",
    "lightbulb"
  ],
  FDOH4: [
    "Rebellious",
    "You have a rebellious streak that resists conformity. You have no problems with breaking rules that don't make sense to you, and question established rules and frameworks. These are positive traits when you're creatively solving problems, but it can work against you if you're always trying to reinvent the wheel (when the wheel works just fine).",
    "user-secret"
  ],
  FDOH5: [
    "Explorer",
    "You can handle whatever life throws at you because of your flexible approach to problems. But this trait also means it takes you longer to make decisions. Try limiting your ideas to a key few based on what may have worked for you in the past.",
    "compass"
  ],

  FDOL1: [
    "Routine",
    "You like following a set plan. Too much changing and messing around can frustrate you because it takes you away from your goals. You thrive when things are predictable.",
    "list-ol"
  ],
  FDOL2: [
    "Black and white",
    "You tend to see things in black and white - there are no shades of grey in between. So, you can quickly jump to conclusions because for you, there's no middle ground. Sometimes, this thinking can limit your conversations and your ability to connect with people who think in colour. You could try exploring different ideas every so often.",
    "map-signs"
  ],
  FDOL3: [
    "Conventional",
    "You don't like to try an untested approach, preferring to stick with what's tried-and-true. However, sometimes following a plan too strictly can affect how you approach new problems, people, or situations. Work on flexibility.",
    "university"
  ]
};

export const personas = {
  personablePersona: {
    id: "p01",
    title: "Personable Persona",
    description:
      "The Personable Persona thrives on social interactions and genuinely enjoys connecting with others. They often find themselves experiencing and expressing positive emotions, making them highly appealing to those around them. Their innate desire to assist others makes them a natural fit for careers in helping professions such as counseling, teaching, nursing, and human services. Others describe them as cheerful, confident, sociable, energetic, enthusiastic, and friendly individuals.",
    tags: ["enthusiastic", "happy", "friendly", "cheerful"],
    image: "p01.svg",
    strenghts: ["FSEH1", "FSEH2", "FSEH3"],
    weaknesses: ["FDAH1", "FDAH2", "FDAH3"]
  },
  domineeringPersona: {
    id: "p02",
    title: "Power Persona",
    description:
      "The Power Persona has strong leadership potential and naturally gravitates toward positions of authority. They are determined and assertive, with a goal-oriented approach. Opportunities to balance emotional awareness allow them to lead effectively while considering the impact on others.",
    tags: ["determined", "decisive", "direct", "strong"],
    image: "p02.svg",
    strenghts: ["FSEH1", "FSEH2", "FSAL1"],
    weaknesses: ["FDAL1", "FDAL2", "FDAL3"]
  },
  humblePersona: {
    id: "p03",
    title: "Humble Persona",
    description:
      "Humble Personas are warm, gentle, and peace-loving. They tend to get along, thrive on social acceptance and go with the majority. People describe them as calm, easy-going, and pleasant.",
    tags: ["soft-hearted", "agreeable", "obliging", "humble", "lenient"],
    image: "p03.svg",
    strenghts: ["FSEL1", "FSAH1", "FSAH2"],
    weaknesses: ["FDAH1", "FDEL1", "FDAH3"]
  },
  distantPersona: {
    id: "p04",
    title: "Independent Persona",
    description:
      "The Independent Persona finds solace and fulfillment in their own company, cherishing moments of solitude. They have a preference for personal reflection and introspection over constant social interactions. Others often perceive them as individuals who appreciate their own space and describe them as reflective, introspective, and thoughtful. However, it's important to note that their inclination for personal introspection may sometimes lead to misunderstandings, as they may be seen as reserved or distant.",
    tags: ["cautious", "independent", "reserved", "private", "skeptical"],
    image: "p04.svg",
    strenghts: ["FSEL3", "FSEL2", "FSEL1"],
    weaknesses: ["FDAL4", "FDAL5", "FDEL1"]
  },
  enterprisingPersona: {
    id: "p05",
    title: "Enterprising Persona",
    description:
      "Enterprising Personas are ambitious, competitive and driven to achieve success. They are purposeful about their life. Because of these motivators, they'll most likely desire being in positions of authority.",
    tags: ["ambitious", "alert", "firm", "purposeful", "competitive"],
    image: "p05.svg",
    strenghts: ["FSEH4", "FSCH1", "FSCH3"],
    weaknesses: ["FDEH1", "FDCH1", "FDCH4"]
  },
  impulsivePersona: {
    id: "p06",
    title: "Spontaneous Persona",
    description:
      "The Spontaneous Persona thrives in social settings and brings energy and liveliness to any group. Their natural sociability and confidence make them a dynamic presence, with a love for spontaneity and a willingness to take risks.",
    tags: ["energetic", "sociable", "free-spirited", "vibrant"],
    image: "p06.svg",
    strenghts: ["FSEH4", "FSCH1", "FSCH3"],
    weaknesses: ["FDCL4", "FDCL3", "FDEH4"]
  },
  industriousPersona: {
    id: "p07",
    title: "Diligent Persona",
    description:
      "The Diligent Persona exemplifies orderliness and self-discipline. They demonstrate unwavering perseverance and a strong work ethic in pursuit of their goals. They possess the ability to work effectively and efficiently without constant supervision, often preferring to work independently. The Diligent Persona holds great respect for rules and societal norms. Others perceive them as thoughtful, cooperative, and responsible individuals.",
    tags: ["cautious", "confident", "punctual", "formal", "efficient"],
    image: "p07.svg",
    strenghts: ["FSCH3", "FSCH4", "FSEL4"],
    weaknesses: ["FDEL4", "FDCH1", "FDEL1"]
  },
  apatheticPersona: {
    id: "p08",
    title: "Easy-going Persona",
    description:
      "The Easygoing Persona adapts well to changing circumstances and values a steady, relaxed approach. While they may be laid-back, they are dependable and enjoy consistent progress in their work and relationships.",
    tags: ["steady", "adaptable", "calm", "content"],
    image: "p08.svg",
    strenghts: ["FSCL2", "FSEL1", "FSCL4"],
    weaknesses: ["FDCL4", "FDEL4", "FDEL2"]
  },
  selfconfidentPersona: {
    id: "p09",
    title: "Sociable Persona",
    description:
      "The Sociable Persona thrives in social settings, exuding confidence and a positive energy. Their outgoing nature and self-assurance make them well-suited for leadership positions. Others perceive them as friendly, self-assured, dynamic, and driven individuals.",
    tags: ["carefree", "self confident", "comfortable"],
    image: "p09.svg",
    strenghts: ["FSEH4", "FSEH3", "FSNL1"],
    weaknesses: ["FDEH5", "FDNL2", "FDEH3"]
  },
  moodymanicPersona: {
    id: "p10",
    title: "Expressive Persona",
    description:
      "The Expressive Persona is emotionally attuned and wears their heart on their sleeve, bringing a passionate and lively energy to their interactions. While they are enthusiastic, they are also open to developing emotional regulation to balance their expressiveness.",
    tags: ["passionate", "expressive", "dynamic", "enthusiastic"],
    image: "p10.svg",
    strenghts: ["FSNH3", "FSEH5", "FSEH4"],
    weaknesses: ["FDEH4", "FDNH3", "FDNH1"]
  },
  satisfiedPersona: {
    id: "p11",
    title: "Satisfied Persona",
    description:
      "Satisfied Personas feel content with things just as they are. They don't see a point in fighting to be at the top of the heap. Stability and security are most important to Satisfied Personas. So, they'll likely be happy in a respectable job earning enough money to live a good and 'regular' life. Others may describe them as responsible, balanced, and humble.",
    tags: ["unassuming", "content", "placid", "tranquil"],
    image: "p11.svg",
    strenghts: ["FSEL1", "FSNL2", "FSEL2"],
    weaknesses: ["FDEL3", "FDEL4", "FDNL1"]
  },
  discouragedPersona: {
    id: "p12",
    title: "Hopeful Persona",
    description:
      "The Hopeful Persona remains resilient in the face of challenges, drawing on their inner strength to find positivity and hope. They view uncertainties as opportunities for growth, steadily working toward self-confidence and future aspirations.",
    tags: ["hopeful", "resilient", "cautiously optimistic"],
    image: "p12.svg",
    strenghts: ["FSNH2", "FSEL3", "FSEL2"],
    weaknesses: ["FDNH1", "FDNH3", "FDEL4"]
  },
  debonairPersona: {
    id: "p13",
    title: "Charming Persona",
    description:
      "Charming Personas are witty and likeable - intelligent extraverts. They can be super dramatic and comical; fun to be around. So, people are naturally attracted to them and describe them as confident, eloquent, and progressive. But if a Charming Persona dislikes someone, they can quickly cut that person out! Ouch. So, these personas can also be seen as critical and blunt when their main tendencies are combined with the wrong levels of agreeableness and neuroticism.",
    tags: ["worldly", "theatrical", "eloquent", "inquisitive", "intense"],
    image: "p13.svg",
    strenghts: ["FSEH1", "FSEH5", "FSOH4"],
    weaknesses: ["FDOH1", "FDEH5", "FDOH2"]
  },
  indescretePersona: {
    id: "p14",
    title: "Confident Persona",
    description:
      "The Confident Persona radiates self-assurance and enjoys engaging with others. Their enthusiasm and openness to sharing ideas make them compelling communicators, and they are continuously improving their active listening skills to connect even more deeply with others.",
    tags: ["confident", "assertive", "charismatic", "expressive"],
    image: "p14.svg",
    strenghts: ["FSEH4", "FSOL1", "FSEH1"],
    weaknesses: ["FDOL3", "FDOL2", "FDEH5"]
  },
  bookwormPersona: {
    id: "p15",
    title: "Bookworm Persona",
    description:
      "Bookworm Personas are very smart and thoughtful people. They're hungry to learn more about their world and who they are as individuals. While they like to keep to themselves and avoid large social gatherings, their intelligence is well known and respected. People may describe them as well-read, calm natured and curious.",
    tags: [
      "introspective",
      "meditative",
      "contemplating",
      "self-examining",
      "inner-directed"
    ],
    image: "p15.svg",
    strenghts: ["FSEL3", "FSOH1", "FSOH4"],
    weaknesses: ["FDOH5", "FDEL3", "FDEL4"]
  },
  lethargicPersona: {
    id: "p16",
    title: "Low-Key Persona",
    description:
      "The Low-Key Persona values stability and is content with familiar routines, finding comfort in reliable relationships and consistent goals. They bring a steady, grounded presence to their environment and can take the lead when needed.",
    tags: ["steady", "reliable", "practical", "calm"],
    image: "p16.svg",
    strenghts: ["FSOL1", "FSOL4", "FSEL4"],
    weaknesses: ["FDEL4", "FDEL2", "FDOL3"]
  },
  compromisingPersona: {
    id: "p17",
    title: "Harmonious Persona",
    description:
      "Harmonious Personas always aim to get along with others because they value 'good' relationships. This means they're likely to be first to compromise to avoid any conflict or showdowns. Others describe them as trustworthy, co-operative, down-to-earth, persevering and understanding.",
    tags: ["dependable", "responsible", "reliable", "mannerly", "considerate"],
    image: "p17.svg",
    strenghts: ["FSAH1", "FSCH4", "FSCH1"],
    weaknesses: ["FDAH1", "FDAH4", "FDCH4"]
  },
  otherdirectedPersona: {
    id: "p18",
    title: "Guided Persona",
    description:
      "Guided Personas are happy just to hang out with their friends and enjoy a breezy life. They are easy-going and prefer being guided by other people, as they aren't opinionated. Others describe them as relaxed, humble, and agreeable.",
    tags: ["unpretentious", "considerate", "modest"],
    image: "p18.svg",
    strenghts: ["FSAH2", "FSAH3", "FSCL2"],
    weaknesses: ["FDCL2", "FDAH3", "FDAH2"]
  },
  moralisticPersona: {
    id: "p19",
    title: "Principled Persona",
    description:
      "Principled Personas are rule-oriented achievers who aim to get the job 'done right'. Sometimes, this means they ignore the feelings of others. That's because principles are more important to them than people. Principled Personas work hard to achieve goals and often show strong initiative, which helps propel them into leadership roles. They believe in working with and through the system to get ahead. They're unlikely to take big risks or be seen mucking around. Others describe them as serious, quiet, and firm.",
    tags: ["stern", "rule following", "uncompromising", "detail focused"],
    image: "p19.svg",
    strenghts: ["FSCH4", "FSAL3", "FSCH5"],
    weaknesses: ["FDAL3", "FDCH3", "FDAL4"]
  },
  selfcenteredPersona: {
    id: "p20",
    title: "Individualistic Persona",
    description:
      "The Individualistic Persona values their independence and self-reliance, prioritizing their own needs and aspirations. They assert their independence and have a strong will, unswayed by the opinions or expectations of others. Others may perceive them as self-reliant, determined, and at times unpredictable or cheeky. It's worth noting that their individualistic mindset may occasionally lead to perceptions of being unreliable, as they prioritize their own individual journey over conforming to the expectations of others.",
    tags: ["independent", "strong willed", "assured", "individualistic"],
    image: "p20.svg",
    strenghts: ["FSCL5", "FSCL1", "FSAL2"],
    weaknesses: ["FDAL6", "FDAL1", "FDCL3"]
  },
  pleasantPersona: {
    id: "p21",
    title: "Pleasant Persona",
    description:
      "Pleasant Personas are full of positive emotions and free from negative emotions. They're widely liked because of their relaxed, down-to-earth nature. Others describe them as cheerful, warm, tolerant, calm, cooperative and kind.",
    tags: ["patient", "relaxed", "undemanding", "down-to-earth"],
    image: "p21.svg",
    strenghts: ["FSAH3", "FSAH2", "FSNL3"],
    weaknesses: ["FDNL2", "FDAH2", "FDAH4"]
  },
  emotionalPersona: {
    id: "p22",
    title: "Empathetic Persona",
    description:
      "The Empathetic Persona is highly attuned to their emotions, experiencing both positive and negative feelings deeply. They possess qualities typically associated with compassion and understanding, such as being agreeable, trusting, affectionate, sensitive, and caring.",
    tags: ["agreeable", "trusting", "affectionate", "sensitive", "caring"],
    image: "p22.svg",
    strenghts: ["FSAH2", "FSNH3", "FSNH4"],
    weaknesses: ["FDNH1", "FDNH4", "FDAH1"]
  },
  unemotionalPersona: {
    id: "p23",
    title: "Stoic Persona",
    description:
      "The Stoic Persona brings emotional resilience and composure to their interactions, staying steady under pressure. While they maintain a composed demeanor, they are also open to connecting emotionally when the situation calls for it.",
    tags: ["resilient", "composed", "emotionally strong"],
    image: "p23.svg",
    strenghts: ["FSAL3", "FSNL1", "FSAL2"],
    weaknesses: ["FDNL3", "FDAL2", "FDAL4"]
  },
  moodyPersona: {
    id: "p24",
    title: "Emotionally Dynamic Persona",
    description:
      "The Emotionally Dynamic Persona is highly passionate and attuned to their emotions. They channel this intensity constructively, continually developing emotional regulation skills to balance their enthusiasm and determination.",
    tags: ["passionate", "emotionally aware", "sensitive"],
    image: "p24.svg",
    strenghts: ["FSAL2", "FSNH2", "FSNH3"],
    weaknesses: ["FDNH3", "FDNH2", "FDAL6"]
  },
  tolerantPersona: {
    id: "p25",
    title: "Open Persona",
    description:
      "Open Personas are easy-going and accepting of differences in other people. As they care about the feelings of others, they'll consider all opinions when making decisions. They get on well with almost everyone they meet, so most people see them as friendly, calm, and thoughtful.",
    tags: ["tolerant", "diplomatic", "deep", "friendly", "tactful"],
    image: "p25.svg",
    strenghts: ["FSAH3", "FSAH4", "FSOH2"],
    weaknesses: ["FDOH5", "FDAH3", "FDAH2"]
  },
  gulliblePersona: {
    id: "p26",
    title: "Trusting Persona",
    description:
      "The Trusting Persona enjoys working collaboratively and places trust in others, believing in the power of shared goals. Their positive outlook encourages harmony in group settings, while they maintain their independence when needed.",
    tags: ["trusting", "collaborative", "down-to-earth", "humble"],
    image: "p26.svg",
    strenghts: ["FSAH2", "FSAH3", "FSOL3"],
    weaknesses: ["FDOL3", "FDAH5", "FDAH3"]
  },
  individualisticPersona: {
    id: "p27",
    title: "Distinct Persona",
    description:
      "The Distinct Persona perceives themselves as having a one-of-a-kind perspective on life. They possess a distinctive and often unconventional approach. At times, their uniqueness may manifest as eccentricity. However, they are primarily recognized for their vivid imagination, intellect, and contagious enthusiasm.",
    tags: ["sharp", "eccentric", "individualistic"],
    image: "p27.svg",
    strenghts: ["FSAL1", "FSOH7", "FSOH5"],
    weaknesses: ["FDOH1", "FDOH3", "FDAL5"]
  },
  narrowmindedPersona: {
    id: "p28",
    title: "Straightforward Persona",
    description:
      "The Straightforward Persona communicates directly and values honesty in all interactions. Their clear and focused approach is appreciated by those who seek straightforward guidance, and they continue to cultivate openness toward new perspectives.",
    tags: ["direct", "focused", "honest"],
    image: "p28.svg",
    strenghts: ["FSOL2", "FSAL2"],
    weaknesses: ["FDAL5", "FDAL4", "FDOL2"]
  },
  persistentPersona: {
    id: "p29",
    title: "Persistent Persona",
    description:
      "Persistent Personas are hard-working, steady and committed. They work well  when they have rules and systems to follow (which they'll always stick to!). Others see them as trustworthy, predictable, and level-headed.",
    tags: ["committed", "objective", "steady", "logical", "rule following"],
    image: "p29.svg",
    strenghts: ["FSCH1", "FSCH6", "FSNL1"],
    weaknesses: ["FDNL1", "FDCH1", "FDCH5"]
  },
  fussyPersona: {
    id: "p30",
    title: "Fussy Persona",
    description:
      "The Fussy Persona values precision and organization, striving for excellence in everything they do. While they appreciate structure, they are learning to embrace flexibility in their goals, allowing them to achieve success without sacrificing quality.",
    tags: ["detail-oriented", "careful", "precise"],
    image: "p30.svg",
    strenghts: ["FSNH3", "FSNH2", "FSCH4"],
    weaknesses: ["FDCH6", "FDCH3", "FDNH5"]
  },
  carefreePersona: {
    id: "p31",
    title: "Carefree Persona",
    description:
      "Carefree Personas are cool, simple, happy-go-lucky types. They don't care about rules and routines, but they aren't against them either. They just go with the flow as their heart pleases. Others describe them as free, flexible, and casual.",
    tags: ["informal", "low-key", "composed"],
    image: "p31.svg",
    strenghts: ["FSCL1", "FSCL2", "FSNL3"],
    weaknesses: ["FDNL1", "FDCL2", "FDCL1"]
  },
  scatteredPersona: {
    id: "p32",
    title: "Flexible Persona",
    description:
      "The Flexible Persona may occasionally feel unsure about their life direction, leading to a flexible mindset that can influence their thoughts and interactions with others. They have a tendency to adapt to changing circumstances, which can sometimes result in forgetfulness. In social situations, they display a genuine curiosity and a strong interest in getting to know others. However, their impulsive nature may cause them to act without much prior consideration, which can be perceived as unpredictable. Others may find them intriguing yet challenging to fully understand.",
    tags: ["spontaneous", "self-indulgent", "curious", "changing"],
    image: "p32.svg",
    strenghts: ["FSCL3", "FSCL4", "FSNH3"],
    weaknesses: ["FDCL3", "FDNH1", "FDCL4"]
  },
  culturedPersona: {
    id: "p33",
    title: "Cultured Persona",
    description:
      "Cultured Personas are big, creative thinkers with a super analytical approach. They are reserved and persevering. Some may have a classy or refined nature, for example, formal manners or stylish clothing. Wise and intuitive, they're able to solve big problems quickly. Cultured Personas have an eye for details, so they suit jobs needing concentration. Other people can see them as rule-abiding, dependable, curious, leader-like, and reliable.",
    tags: [
      "analytical",
      "perceptive",
      "informative",
      "articulate"
    ],
    image: "p33.svg",
    strenghts: ["FSOH6", "FSOH7", "FSCH4"],
    weaknesses: ["FDCH6", "FDOH1", "FDCH1"]
  },
  conventionalPersona: {
    id: "p34",
    title: "Process Persona",
    description:
      "Process Personas prefer to 'go by the book' and follow traditions. Rarely will they improvise or try something different there is a proven approach to follow. They are responsible and can be relied on to follow directions and get the job done. Others see them as agreeable, uncomplicated, and down-to-earth.",
    tags: ["conventional", "traditional", "reliable", "risk averse"],
    image: "p34.svg",
    strenghts: ["FSCH1", "FSCH2", "FSOL1"],
    weaknesses: ["FDOL3", "FDCH4", "FDCH3"]
  },
  imaginativePersona: {
    id: "p35",
    title: "Imaginative Persona",
    description:
      "Imaginative Personas are unique individuals who skip to their own tune in life. They pride themselves on being different to everyone else. They are carefree and fanciful, not really ever thinking about conforming to reality or they way others think. Imaginative Personas can be off on a tangent doing things their own way. They can be seen as creative, non-conforming, and complex.",
    tags: ["unconventional", "quirky", "curious", "individualistic"],
    image: "p35.svg",
    strenghts: ["FSCL1", "FSCL3", "FSOH7"],
    weaknesses: ["FDOH2", "FDOH4", "FDCL6"]
  },
  immaturePersona: {
    id: "p36",
    title: "Adventurous Persona",
    description:
      "Adventurous Personas love thrills, action, and adventure. As such, they can get restless and find it hard to concentrate in classrooms or boring office jobs. To make life more interesting, they may do things suddenly before thinking it through. They work well when they can be hands-on, active instead of passive. Others may perceive them as free-spirited, daring, unpredictable, and non-conformist.",
    tags: ["free-spirited", "risk inclined", "action seeking", "restless"],
    image: "p36.svg",
    strenghts: ["FSCL1", "FSCL3", "FSOL2"],
    weaknesses: ["FDOL2", "FDCL3", "FDCL5"]
  },
  clearthinkingPersona: {
    id: "p37",
    title: "Clear-Thinking Persona",
    description:
      "Clear-Thinking Personas are curious, calm, and bright. They confidently solve problems in a casual, matter-of-fact way. Others may see them as big-thinking, innovative, hard-working, and bright.",
    tags: ["creative", "intellectual", "insightful", "versatile", "inventive"],
    image: "p37.svg",
    strenghts: ["FSNL1", "FSOH5", "FSOH4"],
    weaknesses: ["FDOH3", "FDOH5", "FDNL3"]
  },
  downtoearthPersona: {
    id: "p38",
    title: "Down-To-Earth Persona",
    description:
      "Down-to-Earth Personas focus on the here and now, and stick to values that feel true to them. As they don't hold onto thoughts or past events for long, they rarely feel anxious. While some people may see them as easy-going, hands-on, and full of common sense - others may see that as being raw and comfortable with habit.",
    tags: ["calm", "composed", "traditional", "concrete"],
    image: "p38.svg",
    strenghts: ["FSNL2", "FSOL1", "FSOL3"],
    weaknesses: ["FDNL1", "FDOL1", "FDNL2"]
  },
  sensitivePersona: {
    id: "p39",
    title: "Sensitive Persona",
    description:
      "Sensitive Personas are highly curious but tend wear their heart on their sleeve. They are highly open to new experiences but can find feedback, especially negative feedback, hard to take or easily hurt by others. Their experience can strongly affect how they feel. People may see them as having big imaginations and big feelings that can be hard to understand.",
    tags: ["excitable", "passionate", "experiential"],
    image: "p39.svg",
    strenghts: ["FSNH2", "FSOH1", "FSOH7"],
    weaknesses: ["FDOH2", "FDNH4", "FDNH3"]
  },
  muddledPersona: {
    id: "p40",
    title: "Steadfast Persona",
    description:
      "Steadfast Personas value stability and find comfort in familiar and predictable situations. They prefer to work with things they can fully grasp and have a deep understanding of. When faced with unfamiliar or uncertain circumstances, they may experience some apprehension or hesitation. To maintain a sense of security, they tend to stick to conventional methods and approaches that they are familiar with. Others may perceive them as dependable, cautious, and more inclined towards traditional ways of doing things.",
    tags: ["concrete", "practical", "cautious", "conventional"],
    image: "p40.svg",
    strenghts: ["FSNH1", "FSOL1", "FSOL4"],
    weaknesses: ["FDOL3", "FDNH1", "FDNH2"]
  }
};

export const reporting = {
  ope: {
    high:
      "Your score on Openness to Experience is high, indicating you enjoy novelty, variety, and change. You are curious, imaginative, and creative.",
    average:
      "Your score on Openness to Experience is average, indicating you enjoy tradition but are willing to try new things. Your thinking is neither simple nor complex. You tend to balance pragmatism vs exploring new ways or 'outside of the box' thinking.",
    low:
      "Your score on Openness to Experience is low, indicating you like to think in plain and simple terms. Others describe you as pragmatic, practical, and conservative.",
    description:
      "<p>Openness to Experience describes a dimension of cognitive style that distinguishes imaginative, creative people from down-to-earth, conventional people. Open people are intellectually curious, appreciative of art, and sensitive to beauty. They tend to be, compared to closed people, more aware of their feelings. They tend to think and act in individualistic and nonconforming ways. Intellectuals typically score high on Openness to Experience; consequently, this factor has also been called Culture or Intellect. Nonetheless, Intellect is probably best regarded as one aspect of openness to experience. Scores on Openness to Experience are only modestly related to years of education and scores on standard intelligence tests.</p><p>Another characteristic of the open cognitive style is a facility for thinking in symbols and abstractions far removed from concrete experience. Depending on the individual's specific intellectual abilities, this symbolic cognition may take the form of mathematical, logical, or geometric thinking, artistic and metaphorical use of language, music composition or performance, or one of the many visual or performing arts. People with low scores on openness to experience tend to have narrow, common interests. They prefer the plain, straightforward, and obvious over the complex, ambiguous, and subtle. They may regard the arts and sciences with suspicion, regarding these endeavors as abstruse or of no practical use. Closed people prefer familiarity over novelty; they are conservative and resistant to change.</p><p>Openness is often presented as healthier or more mature by psychologists, who are often themselves open to experience. However, open and closed styles of thinking are useful in different environments. The intellectual style of the open person may serve a professor well, but research has shown that closed thinking is related to superior job performance in police work, sales, and a number of service occupations.</p>"
  },
  con: {
    high:
      "Your score on Conscientiousness is high. This means you set clear goals and pursue them with determination. People regard you as reliable and hard-working.",
    average:
      "Your score on Conscientiousness is average. This means you are reasonably reliable, organized, and self-controlled.",
    low:
      "Your score on Conscientiousness is low, indicating you like to live for the moment and do what feels good now. Your work tends to be careless and disorganized.",
    description:
      "<p>Conscientiousness concerns the way in which we control, regulate, and direct our impulses. Impulses are not inherently bad; occasionally time constraints require a snap decision, and acting on our first impulse can be an effective response. Also, in times of play rather than work, acting spontaneously and impulsively can be fun. Impulsive individuals can be seen by others as colorful, fun-to-be-with, and zany.</p><p>Nonetheless, acting on impulse can lead to trouble in a number of ways. Some impulses are antisocial. Uncontrolled antisocial acts not only harm other members of society, but also can result in retribution toward the perpetrator of such impulsive acts. Another problem with impulsive acts is that they often produce immediate rewards but undesirable, long-term consequences. Examples include excessive socializing that leads to being fired from one's job, hurling an insult that causes the breakup of an important relationship, or using pleasure-inducing drugs that eventually destroy one's health.</p><p>Impulsive behavior, even when not seriously destructive, diminishes a person's effectiveness in significant ways. Acting impulsively disallows contemplating alternative courses of action, some of which would have been wiser than the impulsive choice. Impulsivity also sidetracks people during projects that require organized sequences of steps or stages. Accomplishments of an impulsive person are therefore small, scattered, and inconsistent.</p><p>A hallmark of intelligence, what potentially separates human beings from earlier life forms, is the ability to think about future consequences before acting on an impulse. Intelligent activity involves contemplation of long-range goals, organizing and planning routes to these goals, and persisting toward one's goals in the face of short-lived impulses to the contrary. The idea that intelligence involves impulse control is nicely captured by the term prudence, an alternative label for the Conscientiousness domain. Prudent means both wise and cautious. Persons who score high on the Conscientiousness scale are, in fact, perceived by others as intelligent.</p><p>The benefits of high conscientiousness are obvious. Conscientious individuals avoid trouble and achieve high levels of success through purposeful planning and persistence. They are also positively regarded by others as intelligent and reliable. On the negative side, they can be compulsive perfectionists and workaholics. Furthermore, extremely conscientious individuals might be regarded as stuffy and boring. Unconscientious people may be criticized for their unreliability, lack of ambition, and failure to stay within the lines, but they will experience many short-lived pleasures and they will never be called stuffy.</p>"
  },
  ext: {
    high:
      "Your score on Extraversion is high, indicating you are sociable, outgoing, energetic, and lively. You prefer to be around people much of the time.",
    average:
      "Your score on Extraversion is average, indicating you are neither completely subdued nor a jovial chatterbox. You enjoy time with others but also time alone.",
    low:
      "Your score on Extraversion is low, indicating you are introverted, reserved, and quiet. You enjoy solitude and solitary activities. Your socializing tends to be restricted to a few close friends.",
    description:
      "<p>Extraversion is marked by pronounced engagement with the external world. Extroverts enjoy being with people, are full of energy, and often experience positive emotions. They tend to be enthusiastic, action-oriented, individuals who are likely to say 'Yes!' or 'Let's go!' to opportunities for excitement. In groups they like to talk, assert themselves, and draw attention to themselves.</p><p>Introverts lack the exuberance, energy, and activity levels of extraverts. They tend to be quiet, low-key, deliberate, and disengaged from the social world. Their lack of social involvement should not be interpreted as shyness or depression; the introvert simply needs less stimulation than an extravert and prefers to be alone. The independence and reserve of the introvert is sometimes mistaken as unfriendliness or arrogance. In reality, an introvert who scores high on the agreeableness dimension will not seek others out but will be quite pleasant when approached.</p>"
  },
  agr: {
    high:
      "Your high level of Agreeableness indicates a strong interest in others' needs and well-being. You are pleasant, sympathetic, and cooperative.",
    average:
      "Your level of Agreeableness is average, indicating you tend to balance concern for the needs of others and your own.",
    low:
      "Your score on Agreeableness is low, indicating that you show less concern for the needs of others than with your own. People see you as tough, critical, and uncompromising.",
    description:
      "<p>Agreeableness reflects individual differences in concern with cooperation and social harmony. Agreeable individuals value getting along with others. They are therefore considerate, friendly, generous, helpful, and willing to compromise their interests with others'. Agreeable people also have an optimistic view of human nature. They believe people are basically honest, decent, and trustworthy.</p><p>Disagreeable individuals place self-interest above getting along with others. They are generally unconcerned with others' well-being, and therefore are unlikely to extend themselves for other people. Sometimes their skepticism about others' motives causes them to be suspicious, unfriendly, and uncooperative.</p><p>Agreeableness is obviously advantageous for attaining and maintaining popularity. Agreeable people are better liked than disagreeable people. On the other hand, agreeableness is not useful in situations that require tough or absolute objective decisions. Disagreeable people can make excellent scientists, critics, or soldiers.</p>"
  },
  neu: {
    high:
      "Your score on Neuroticism is high, indicating that you are easily upset, even by what most people consider the normal demands of living. People consider you to be sensitive and emotional.",
    average:
      "Your score on Neuroticism is average, indicating that your level of emotional reactivity is typical. Stressful and frustrating situations are somewhat upsetting to you, but you are generally able to get over these feelings, move on and cope.",
    low:
      "Your score on Neuroticism is low, indicating that you are exceptionally calm, composed and unflappable. You do not react with intense emotions, even to situations that most people would describe as stressful.",
    description:
      "<p>Neuroticism can be used to describe an individual's level of mental distress, emotional suffering, and an ability to cope effectively with the normal demands of life. All individuals have varying amounts of emotionality, but we differ in our degree of suffering and our specific symptoms of distress.</p><p>Typically, Neuroticism refers to the tendency to experience negative feelings. Those who score high on Neuroticism may experience primarily one specific negative feeling such as anxiety, anger, or depression, but are likely to experience several of these emotions. People high in Neuroticism can also be emotionally reactive. They respond emotionally to events that would not affect most people, and their reactions tend to be more intense than normal. They are more likely to interpret ordinary situations as threatening, and minor frustrations as hopelessly difficult. Their negative emotional reactions tend to persist for unusually long periods of time, which means they are often in a bad mood. These problems in emotional regulation can diminish the ability to think clearly, make decisions, and cope effectively with stress.</p><p>At the other end of the scale, individuals who score low in Neuroticism are less easily upset and are less emotionally reactive. They tend to be calm, emotionally stable, and free from persistent negative feelings. Freedom from negative feelings does not mean that low scorers experience a lot of positive feelings; frequency of positive emotions is also a component of the Extraversion domain.</p>"
  }
};